import React, { useEffect, useState } from "react";

const AllowanceBox = ({ jobAllowancedata, jobDataMain }) => {
  const [totalAllowance, setTotalAllowance] = useState(0);

  useEffect(() => {
    let total = 0;

    // Ensure jobAllowancedata is an array before iterating
    if (Array.isArray(jobAllowancedata)) {
      jobAllowancedata.forEach((jobdata) => {
        if (jobdata?.TotalAllowance && jobdata?.TotalAllowance > 0) {
          total += jobdata.TotalAllowance;
        }
      });
    }

    // Get the incentive amount, defaulting to 0 if undefined or null
    const totalIncentiveAmount = jobDataMain[0]?.TotalIncentiveAmount || 0;

    if (totalIncentiveAmount > 0) {
      total += totalIncentiveAmount;
    }

    // Update state
    setTotalAllowance(total);
  }, [jobAllowancedata, jobDataMain]);

  // Format currency for display
  const formattedTotalAllowance =
    totalAllowance > 0
      ? new Intl.NumberFormat("en-IN", {
          style: "currency",
          currency: "INR",
          maximumFractionDigits: 2,
        }).format(totalAllowance)
      : ""; // Don't show anything if total is 0

  return (
    <div className="allowance-box">
      {/* Render job allowances only if value > 0 */}
      {Array.isArray(jobAllowancedata) &&
        jobAllowancedata
          .filter(
            (jobdata) => jobdata?.TotalAllowance && jobdata?.TotalAllowance > 0 // ✅ Ensures zero values are filtered out
          )
          .map((jobdata, index) => (
            <p key={index} className="allowance-show">
              {(() => {
                const allowanceMapping = {
                  TLA: "TL Allowance",
                  SPA: "Supervisor Allowance",
                  UGA: "UG Allowance",
                  SWA: "SW Allowance",
                };
                return `${
                  allowanceMapping[jobdata?.AllowanceType] ||
                  jobdata?.AllowanceType
                } : ₹${jobdata?.TotalAllowance}`;
              })()}
            </p>
          ))}

      {/* Incentive and Total - Hide Incentive if 0 */}
      {jobDataMain[0]?.TotalIncentiveAmount > 0 && (
        <p className="allowance-show">
          Incentive : &#x20B9;{jobDataMain[0]?.TotalIncentiveAmount}
        </p>
      )}

      {/* Show total only if greater than 0 */}
      {totalAllowance > 0 && (
        <div className="allowant-total-box">
          <p className="allowance-price">Total : {formattedTotalAllowance}</p>
        </div>
      )}
    </div>
  );
};

export default AllowanceBox;
